import type {Metrics} from 'src/metrics';

/**
 * A no-operation (noop) metrics implementation that performs no metric recording.
 */
export const noopMetrics: Metrics = {
  increment: () => {
    // noop
  },
  gauge: () => {
    // noop
  },
  set: () => {
    // noop
  },
};
